"use strict";
/** Игнорирует вызовы до определённого времени, в конце вызывает последний вызов
 * @param {function} fn - вызываемая функция
 * @param {string} delay - время игнора вызовов
 */var debounce=function(n,o){var r;return function(){for(var e=[],t=0;t<arguments.length;t++)e[t]=arguments[t];clearTimeout(r),r=setTimeout(function(){return n.apply(void 0,e)},o)}};module.exports=debounce;
